import Script from 'next/script';

// Same script ids as GoogleTagManager from @next/third-parties, so next/script never loads GTM
// twice when the user navigates between deferred and regular pages.
export function DeferredGoogleTagManager({
  gtmId,
}: Readonly<{ gtmId: string }>) {
  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      })(window,'dataLayer');`,
        }}
        id='_next-gtm-init'
      />
      <Script
        data-ntpc='GTM'
        id='_next-gtm'
        src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
        strategy='lazyOnload'
      />
    </>
  );
}
